import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { WatchPreview } from '@/app/watch/WatchPreview';

/**
 * Endereço aberto do curso. Quem já entrou vai direto ao player; quem não
 * entrou vê a mesma tela da aula, com o vídeo travado até fazer login.
 */
export const Route = createFileRoute('/_aberto/cursos/$slug/')({
  validateSearch: z.object({
    aula: z.string().optional().catch(undefined),
  }),
  beforeLoad: ({ context, params, search }) => {
    if (context.auth.isAuthenticated)
      throw redirect({
        to: '/cursos/$slug/assistir',
        params: { slug: params.slug },
        search: { aula: search.aula },
        replace: true,
      });
  },
  component: function CoursePreviewRoute() {
    const { slug } = Route.useParams();
    const { aula } = Route.useSearch();
    return <WatchPreview slug={slug} lessonId={aula} />;
  },
});
